// extracted by mini-css-extract-plugin
export default {"createButton":"OmniButton-module__createButton___CyhfB","omniButton":"OmniButton-module__omniButton___bwrUI"};